import styled from 'styled-components';
import { MIN_TOTAL_PADDED, SIDE_PAD } from './Service/gridConfig';

export const ListContainer = styled.div`
  background: #f6f8fb;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  margin-top: 8px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  max-height: ${(p) => (p.$fs ? 'unset' : '60vh')};
  flex: ${(p) => (p.$fs ? '1 1 auto' : '0 0 auto')};

  padding-inline: ${SIDE_PAD}px;
  scrollbar-gutter: stable both-edges;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background: #f6f8fb;
  box-sizing: border-box;
  border-bottom: 1px solid #d9e6f8ff;
  padding: 0;
  min-width: ${MIN_TOTAL_PADDED}px;
  width: max(100%, ${MIN_TOTAL_PADDED}px);
  box-shadow: ${(p) => (p.$elevate ? '0 2px 6px rgba(0,0,0,.06)' : 'none')};
  transition: box-shadow .15s ease;
`;

export const HeaderInner = styled.div`
  box-sizing: border-box;
  padding-inline: ${SIDE_PAD}px;
  min-width: ${MIN_TOTAL_PADDED}px;
  width: max(100%, ${MIN_TOTAL_PADDED}px);
`;

export const ListBody = styled.div`
  overflow-y: auto;
  flex: 1 1 auto;
`;

export const FilterBarWrap = styled.div`
  position: relative;
  z-index: 2;

  margin-top: -24px;
  margin-bottom: 8px;
  margin-left: -50px;
  padding: 12px 0 10px 50px;

  &::before {
    content: '';
    position: absolute;
    inset: -12px calc(50% - 50vw) -8px calc(50% - 50vw);
    background: #143857;
    border-bottom: 1px solid rgba(252, 241, 241, 0.12);
    z-index: -1;
  }
  .top-filter label,
  .top-filter .form-label,
  .top-filter .input-label,
  .top-filter .select__label,
  .top-filter [data-role="field-label"] {
    color: #fff !important;
    opacity: 1 !important;
  }

  .filter { margin-left: 0; margin-right: 0; }
`;
